import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import CloseButton from '@/components/close-button'
import { createModal, useModalize } from '@/components/modalize/mui'
import { toast } from '@/components/toast-notifications'
import PasswordForm from '@/features/Auth/PasswordForm'
import { changePassword } from '@/models/auth/ports'
import handleSession from '@/utils/handle-session'
import { H4 } from '@/components/text'
import { parseErrorMessage } from '@/ports/api'

const Wrapper = styled.div`
  max-height: 95vh;
`

const ScrollWrapper = styled.div`
  height: 100%;
  width: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px 24px 40px;
`

const TitleText = styled(H4)`
  margin-bottom: 24px;
`

const PasswordModal = () => {
  const { t } = useTranslation()
  const { close } = useModalize()
  const dispatch = useDispatch()

  const onSubmit = async (values, { setSubmitting }) => {
    const { response, body } = await changePassword({ body: values })
    setSubmitting(false)
    if (response.ok) {
      await handleSession(dispatch.session.loadSession())
      return (
        toast(
          t('b.auth.edit.password_changed.text', 'Your password has been successfully changed.'),
          {
            title: t('b.auth.edit.password_changed.title', 'Password Changed!'),
            type: 'success'
          }
        ),
        close()
      )
    } else {
      const message = parseErrorMessage(body)
      if (message === 'The data (string) must match the type: null') {
        return toast(
          t(
            'b.auth.edit.password_changed.failed_invald.desc.error',
            'The password you entered is invalid. Please try again.'
          ),
          {
            title: t(
              'b.auth.edit.password_changed.failed_invald.title.error',
              'Incorrect Current Password'
            ),
            type: 'error'
          }
        )
      } else {
        toast(message, { type: 'error' })
      }
    }
  }

  return (
    <Wrapper>
      <CloseButton onClick={close} />
      <ScrollWrapper>
        <TitleText>{t('b.auth.edit.change_password.title', 'Change Password')}</TitleText>
        <PasswordForm onSubmit={onSubmit} />
      </ScrollWrapper>
    </Wrapper>
  )
}

export const showChangePasswordModal = createModal(PasswordModal)
